export type Theme = 'light';

export function resolveInitialTheme(): Theme {
  return 'light';
}

export function applyTheme(_theme?: string): void {
  document.documentElement.setAttribute('data-theme', 'light');
}

export function useTheme() {
  return { theme: 'light' as const, toggle: () => {} };
}

